export { renderProductTourPreview } from '../extensions/product-tours/preview'
